<template>
    <div>

        <b-container fluid>
        <b-row v-if="!lengthOfEvents">
            <i> No events scheduled at this time</i>
        </b-row>

        <b-row  v-for="(item, index) in pubEvents" :key="item.id">
            <b-col style="margin:10px;" sm="*">
                <h5>{{item.eventTimeObject.date}} {{item.eventTimeObject.month}}</h5>
                <p class='graytext'>{{item.eventTimeObject.time}}</p>
            </b-col>

            <b-col style="margin: 10px;">
                <div class='breweryname'>
                    <h5> <a @click="viewBrewerProfile(item.brewerid,item.brewer)">{{item.brewer}}</a> </h5>
                </div>
                <div>
                    <h6><strong>{{item.title}}</strong></h6> 
                    <div class='graytext'>
                        {{item.description}} 
                    </div>
                    
                </div>
            </b-col>

            <b-col>
                    <div v-if="!item.accepted&&!item.full" style="margin-top: 10px; margin-bottom: 10px;">
                                <b-button  variant="primary" v-b-modal="'RSVP' + item.docId">RSVP</b-button>
                                <b-modal :id="'RSVP' + item.docId" title="RSVP" @cancel="cancelPressed()" @ok="OKRSVPPressed(item.id, item.docId, index, item)">
                                    <p class="my-4">Confirm attendance?</p>
                                </b-modal>
                    </div>

                    <div v-else-if="item.accepted&&!item.full" style="margin-top: 10px; margin-bottom: 10px;">
                                <b-button v-b-modal="'CancelRSVP' + item.docId">Cancel RSVP</b-button>
                                <b-modal :id="'CancelRSVP' + item.docId" title="Cancel RSVP"  ok-title ='Yes, Cancel RSVP' cancel-title ='Do Not Cancel RSVP'  @ok="cancelRSVPPressed(item.id, item.docId, index, item)">
                                    <p class="my-4">Cancel RSVP?</p>
                                </b-modal>
                    </div>
                    <div v-else> Event Full </div>
                    <h6 class='graytext'>{{item.spotsremaining}}/{{item.maxAttendees}} Spots Remaining</h6>

            </b-col>

        </b-row>
        
        </b-container>
    </div>
</template>

<script>
    import { mapState } from 'vuex'
    const fb = require('../firebaseConfig.js')
    import firebase from 'firebase/app';

    const db = firebase.firestore()
    const increment = firebase.firestore.FieldValue.increment(1);
    const increment_neg = firebase.firestore.FieldValue.increment(-1);

    export default {
            props: [],
            components: {
        },
        
        computed: {
            ...mapState(['userProfile', 'currentUser', 'pubEvents']),
            lengthOfEvents(){
                return this.pubEvents.length
            }
        },
        data() {
            return {
                loading:false,
            }
        },

        methods: {
            cancelPressed(){
            },
            OKRSVPPressed(eventId, theDocId, eventIndex, event){
                this.loading=true
                var attendee={}
                attendee.uid = this.currentUser.uid
                attendee.name = this.userProfile.company
                fb.eventsCollection.doc(theDocId).update({
                        attendees: firebase.firestore.FieldValue.arrayUnion({attendee: attendee})
                        }).then(docs => {  
                            this.loading=false
                        });
                //Increment attendee count
                fb.eventsCollection.doc(theDocId).update({ attendeeCount: increment });
                fb.eventsCollection.doc(theDocId).update({ spotsremaining: increment_neg });
                this.$store.dispatch('fetchPubEvents')

                // Add to news feed
                var feedString
                var feedObject = {}
                feedObject.createdOn = new Date(),
                feedObject.brewerId = event.brewerid
                feedObject.pubId = this.currentUser.uid
                feedObject.pub = this.userProfile.company
                feedObject.brewer = event.brewer
                feedString = this.userProfile.company + ' confirmed attendance for ' + event.title
                feedObject.feedString = feedString
                this.$store.dispatch('addToNewsFeed',feedObject)
                
            },
            cancelRSVPPressed(id, theDocId, index, event){
                var thisUserId = this.currentUser.uid
                this.loading=true
                fb.eventsCollection.doc(theDocId).update({
                        cancelledrsvp: firebase.firestore.FieldValue.arrayUnion(this.currentUser.uid)
                        }).then(docs => { 
                            this.loading=false
                            fb.eventsCollection.doc(theDocId).update({ attendeeCount: increment_neg });
                            fb.eventsCollection.doc(theDocId).update({ spotsremaining: increment });
                            this.$store.dispatch('fetchPubEvents')
                        })
                        
                        .catch(err => {
                    console.log(err)
                })

                //Now run transaction to update attendees list
                // Create a reference to the SF doc.
                var sfDocRef = fb.eventsCollection.doc(theDocId)
                // Uncomment to initialize the doc.
                // sfDocRef.set({ population: 0 });
                return db.runTransaction(function(transaction) {
                    // This code may get re-run multiple times if there are conflicts.
                    return transaction.get(sfDocRef).then(function(sfDoc) {
                        if (!sfDoc.exists) {
                            throw "Document does not exist!";
                        }
                        var attendeesList = sfDoc.data().attendees
                        var attendeesCount = attendeesList.length
                        var newAtendeesList = []
                        for (var i = 0; i<attendeesCount; i++){
                            var attendeeId = attendeesList[i].attendee.uid
                            if (attendeeId == thisUserId){
                                //Do nothing
                            }
                            else{
                                newAtendeesList.push(attendeesList[i])
                            }
                        }

                        transaction.update(sfDocRef, { attendees: newAtendeesList });
                        
                    });
                }).then(function() {
                    //this.loading=false
                }).catch(function(error) {
                    console.log("Transaction failed: ", error);
                    //this.loading=false
                });

                // Add to news feed
                var feedString
                var feedObject = {}
                feedObject.createdOn = new Date(),
                feedObject.brewerId = event.brewerid
                feedObject.pubId = this.currentUser.uid
                feedObject.pub = this.userProfile.company
                feedObject.brewer = event.brewer
                feedString = this.userProfile.company + ' cancelled attendance for ' + event.title
                feedObject.feedString = feedString
                this.$store.dispatch('addToNewsFeed',feedObject)

                
                //End of transaction
            },
            viewBrewerProfile(brewerId,brewer){
                this.$store.commit('setViewingBrewerId', brewerId)
                this.$store.commit('setViewingBrewerName', brewer)
                this.$router.push({name:'breweryprofile'})
            },
        }
        
    }
</script>